<template>
  <el-card style="width: 32%;">
    <div ref="statistics" style="height: 350px;"></div>
  </el-card>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    statisticsData: Object
  },
  data() {
    return {
      myCharts: null
    }
  },
  watch: {
    statisticsData: {
      handler(val) {
        this.setChart();
      },
      deep: true
    }
  },
  methods: {
    setChart() {
      if (!this.myCharts) {
        this.myCharts = this.$echarts.init(this.$refs.statistics);
      }
      let statisticsData = this.statisticsData;
      if (!statisticsData || Object.keys(statisticsData) == 0) {
        return;
      }

      let seriesData = [];
      for (let key in statisticsData) {
        seriesData.push({ name: key, value: statisticsData[key]})
      }

      this.myCharts.setOption({
        title: {
          text: '性别统计',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '5%',
          left: 'center'
        },
        series: [
          {
            name: '性别统计',
            type: 'pie',
            radius: '70%',
            data: seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      })
    }
  }
})
</script>
